export { AmazonMapDisplay } from './AmazonMapDisplay';
